import React from 'react';
import PropTypes from 'prop-types';
import Header from "semantic-ui-react/dist/es/elements/Header/Header.js";
import classnames from 'classnames';
import { getHeadingNumber } from "./getHeadingNumber";
var SIZES = ['huge', 'large', 'medium', 'small'];
export var Component = function Component(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasMargin = _ref.hasMargin,
      isColorInverted = _ref.isColorInverted,
      size = _ref.size,
      textAlign = _ref.textAlign;
  return React.createElement(Header, {
    as: "h".concat(getHeadingNumber(SIZES, size)),
    className: classnames(className, {
      'has-no-margin': !hasMargin
    }),
    inverted: isColorInverted,
    textAlign: textAlign
  }, children);
};
Component.displayName = 'Heading';
Component.defaultProps = {
  className: null,
  hasMargin: true,
  isColorInverted: false,
  textAlign: null,
  size: 'medium'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  hasMargin: PropTypes.bool,
  isColorInverted: PropTypes.bool,
  size: PropTypes.oneOf(SIZES),
  textAlign: PropTypes.oneOf(['left', 'right', 'justified', 'center'])
} : {};